/* globals wordpress_globals  */
import "../styles/theme.scss";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import moduleDefinition from "@projModules/definition";
import { fetchSVG } from "@projLib/SVGSprite";
import AsyncModules from "@projModules/AsyncModules";
const innerModules = [
    { selector: "[data-death-toll]", moduleName: "DeathCount" },
];
/**
 * Async Modules: Modules are defined in ./modules/definitions.ts
 */
const bootstrap = {
    init() {
        var _a;
        this.asyncSVG.init();
        AsyncModules.init(moduleDefinition);
        ((_a = document.querySelectorAll(".section")) !== null && _a !== void 0 ? _a : []).forEach((el) => {
            el.addEventListener("initiate.events", () => {
                if (!el.classList.contains("initiated")) {
                    AsyncModules.init(innerModules, el);
                }
                el.classList.add("initiated");
            });
        });
        import("@projModules/AnimatedScroll").then((mod) => {
            const Module = mod.default;
            return new Module().init();
        });
    },
    asyncSVG: {
        init() {
            fetchSVG("./wp-content/themes/class/dist/sprite.svg")
                .catch((error) => console.warn(`[fetchSVG] ${error}`));
        },
    },
};
document.addEventListener("DOMContentLoaded", () => {
    bootstrap.init();
});
